import { useEffect } from "react";
import { CalendarDialog } from "@/components/CalendarDialog";
import { Reveal } from "@/components/Reveal";

export function ContactSection() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector(
        'script[src="https://link.msgsndr.com/js/form_embed.js"]'
      );
      if (existingScript) existingScript.remove();
    };
  }, []);

  return (
    <section
      id="contact-section"
      className="section-padding bg-background-dark relative overflow-hidden"
      aria-labelledby="contact-heading"
    >
      <div className="absolute inset-0 grid-pattern-dark opacity-50" />
      <div className="absolute top-0 right-0 w-[400px] sm:w-[700px] h-[400px] sm:h-[700px] bg-primary/[0.06] rounded-full blur-[100px] sm:blur-[180px] translate-x-1/3 -translate-y-1/3" />

      <div className="container-wide relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-start">
          {/* Left — written CTA */}
          <Reveal className="order-1">
            <span className="section-badge-dark mb-4">Next Step</span>
            <h2
              id="contact-heading"
              className="heading-section text-foreground-dark mt-4 mb-5 text-balance"
            >
              Ready to get more of the{" "}
              <span className="heading-accent-dark">right enquiries?</span>
            </h2>
            <p className="text-base sm:text-lg text-foreground-dark/75 leading-[1.7] prose-cap mb-8">
              Tell us where your business is currently getting stuck and we’ll
              recommend the most sensible next step.
            </p>
            <CalendarDialog
              buttonVariant="dark-primary"
              buttonSize="lg"
              buttonClassName="w-full sm:w-auto h-14 px-8 text-base font-bold rounded-xl"
            />
            <p className="text-base text-foreground-dark/50 mt-4">
              Free strategy call • No obligation
            </p>
          </Reveal>

          {/* Right — form */}
          <Reveal
            delay={0.08}
            className="order-2 bg-card rounded-2xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-border/30"
          >
            <iframe
              src="https://api.leadconnectorhq.com/widget/form/diRNWqSDomWX8M6X5NUu"
              style={{
                width: "100%",
                height: "724px",
                border: "none",
                borderRadius: "12px",
              }}
              id="inline-diRNWqSDomWX8M6X5NUu"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-activation-type="alwaysActivated"
              data-deactivation-type="neverDeactivate"
              data-form-name="Trade & Service Business Enquiry Form"
              data-height="724"
              data-layout-iframe-id="inline-diRNWqSDomWX8M6X5NUu"
              data-form-id="diRNWqSDomWX8M6X5NUu"
              title="Enquiry form — FullScale Marketing"
            />
            <p className="text-xs text-muted-foreground text-center px-4 pb-4 pt-2">
              We'll only use your details to respond to your enquiry.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
